<template>
  <div>
    <form class="form-horizontal">
      <div class="form-group lp-flex-box" :class="{'has-error': biz.nickname==''}" style='align:left'>
        <label class="control-label col-sm-3">名称</label>
        <div class="controls col-sm-8">
          <input type="text" name="nickname" id="nickname" v-model="biz.nickname" class="form-control" />
        </div>
        <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.username==''}" style='align:left'>
        <label class="control-label col-sm-3">账号</label>
        <div class="controls col-sm-8">
          <input type="text" name="username" id="username" v-model="biz.username" class="form-control input-sm" />
        </div>
        <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" :class="{'has-error': biz.roleId == 0}" style='align:left'>
        <label class="control-label col-sm-3">角色</label>
        <div class="controls col-sm-8">
          <select class="form-control" id="account-role" v-model="biz.roleId">
            <option value="0">设置角色</option>
            <option v-for="(item, index) in biz.roles" :value="item.id">{{item.description}}</option>
          </select>
        </div>
        <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" style='align:left'>
        <label class="control-label col-sm-3">项目权限</label>
        <div class="controls col-sm-8">
          <select id="select2_sample_modal_2" class="form-control select2" multiple>
            <option  v-for="item in biz.communities" :value="item.id">{{item.description}}</option>
          </select>
        </div>
        <span class="help-inline">必填</span>
      </div>
      <div class="form-group lp-flex-box" style='align:left'>
        <button class="btn" type="button" @click="close">取消</button>
        <button class="btn green" type="button" @click="save">确定</button>
      </div>
    </form>
  </div>
</template>
<script>
import http from '../../lib/utils/request.js'
import commonMethods from '../../lib/methods/common.js'
import mixins from '../../mixins/index'
import { MSG_ID } from '../../lib/constant.js'
export default {
  name: 'roleedit',
  mixins: mixins,
  data() {
    return {
      biz: {
        id: 0,
        nickname: '',
        username: '',
        roleId: 0,
        advertiserId: 0,
        community_ids: '',
        roles: [],
        advertisers: [],
        communities: []
      },
      ui: {}
    }
  },
  mounted () {
    window.$('#select2_sample_modal_2').select2({
      placeholder: '选择项目...',
      allowClear: false
    })
  },
  methods: {
    load() {
      this.loadAccount()
    },
    loadAccount() {
      if (this.biz.id) {
        http.invoke('auth.pageAccount', { id: this.biz.id, account: this.uid(), page_index: 1, page_size: 1 }, (data) => {
          let account = data.content[0]
          this.biz.nickname = account.nickname
          this.biz.username = account.username
          this.biz.roleId = data.ext.role_id
          this.biz.advertiserId = data.ext.advertiser_id
          this.biz.community_ids = account.community_ids
          this.loadRole()
          this.loadCommunities()
        })
      } else {
        this.loadRole()
        this.loadCommunities()
      }
    },
    loadRole() {
      http.invoke('auth.pageRole', { account: this.uid(), page_index: 1, page_size: 100 }, (data) => {
        this.biz.roles = data.content
      })
    },
    loadCommunities() {
      http.invoke('addr.listCommunities', { page_index: 1, page_size: 500 }, (data) => {
        this.biz.communities = data
        setTimeout(() => {
          let c = this.biz.community_ids.split(',')
          if (this.biz.community_ids) {
            window.$('#select2_sample_modal_2').val(c).trigger('change')
          }
        }, 300)
      })
    },
    onShowInModal(...args) {
      let options = args[0]
      this.biz.id = +options['id']
      this.load()
    },
    onHideInModal(...args) {
      this.biz.id = 0
    },
    save() {
      let co = window.$('#select2_sample_modal_2').select2('val')
      console.log(co)
      if (!this.biz.nickname || !this.biz.username || !this.biz.roleId || co.length === 0) {
        return
      }
      let reqdata = { action: 1, nickname: this.biz.nickname, username: this.biz.username, id: this.biz.id, role_id: this.biz.roleId, advertiser_id: this.biz.advertiserId, community_ids: co.join(',') }
      http.invoke('auth.setAccount', reqdata, (data) => {
        window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
        window.emitter.emit(MSG_ID.MSG_ACCOUNT_SET_SUCCESS)
      })
    },
    close() {
      window.emitter.emit(MSG_ID.MSG_UI_HIDE_MODAL)
    },
    ...commonMethods
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #42b983;
}

@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// AccountEdit.vue?534b488a